<template>
  <v-card>
    <v-dialog v-model="dialogCloseChat" persistent max-width="320" v-if="checkForMotif && !hasMotif">
      <v-card>
        <v-card-title class="primary white--text subheading">{{ $t('closeChatTitle') }}</v-card-title>
        <v-card-text>{{ $t('tagBeforeClose') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click="fermeDialog()">{{ $t('cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCloseChat" persistent max-width="500" v-else>
      <!-- dialogueBox messaging -->
      <v-card v-if="$route.fullPath === '/trafic/attente' || directChat">
        <v-card-title class="primary white--text subheading">{{ $t('Fermeture de la conversation') }}</v-card-title>
        <v-card-text>
          <p>
          {{ $t('Votre message a bien été envoyé au visiteur, tous les messages de ce visiteurs ont été supprimés de la liste des messages en attente') }}
          </p>
          Cette conversation se fermera automatiquement dans <wz-timer :timeLeft="timeLeft"/> s

          </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click="fermeDialog()">{{ $t('cancel') }}</v-btn>
          <v-btn class="blue--text darken-1" flat @click="fermeChat()">{{ $t('close') }}</v-btn>
        </v-card-actions>
      </v-card>
      <!-- dialogueBox chat -->
      <v-card v-else>
        <v-card-title class="primary white--text subheading">{{ $t('closeChatTitle') }}</v-card-title>
        <v-card-text>{{ $t('beforeCloseOptions') }}</v-card-text>
        <v-card-text>
          <v-switch
            :disabled="checkSatisfaction"
            :label="$t('sendSatisfactionSurvey')"
            v-model="formulaireSatisfaction"
            v-show="checkKetB"
            hide-details
          ></v-switch>
        </v-card-text>
        <v-card-text>
          <v-switch
            :label="$t('closeThisChat')"
            v-model="clotureChat"
            :hint="$t('closeThisChatHint')"
            persistent-hint
          ></v-switch>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click="fermeDialog()">{{ $t('cancel') }}</v-btn>
          <v-btn class="blue--text darken-1" flat @click="fermeChat()">{{ $t('close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
// import _ from 'lodash'
import { mapGetters, mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      checkForMotif: false,
      formulaireSatisfaction: false,
      clotureChat: false,
      timeLimit: 20,
      timePassed: 0,
      timerInterval: null
    }
  },

  props: ['datasVisiteur', 'dialogCloseChat'],

  methods: {
    ...mapActions('_StoreWatcheeBox', [
      'ACTION_CLOSE_CHAT'
    ]),
    startTimer () {
      this.timerInterval = setInterval(() => (this.timePassed += 1), 1000)
    },
    stopTimer () {
      clearInterval(this.timerInterval)
    },
    onTimesUp () {
      clearInterval(this.timerInterval)
      this.fermeChat()
    },

    // ----------------------------------------------------------------------------
    // close la dialogBox
    // ----------------------------------------------------------------------------
    fermeDialog () {
      // ferme le chat
      this.$emit('fermeDialogCloseChat', {
        dialogCloseChat: false
      })
      if (this.$route.fullPath === '/trafic/attente' || this.directChat) {
        this.stopTimer()
        this.timeLimit = 20
        this.timePassed = 0
      }
    },
/*
    // ----------------------------------------------------------------------------
    // efface les message en attente de ce visiteur si il en reste
    // ----------------------------------------------------------------------------
    checkMessageAttenteVisiteur (data) {
      console.log('checkMessageAttenteVisiteur', data)
      // il faut avant tout regarder si il y a des message en atente de ce visiteur
      let numMessage = 0
      _.forEach(
        this.$store.state._User.colleagues,
        (agent, key) => {
          // console.log('agent', agent)
          if (agent.listeMessages.length) {
            let index = _.findIndex(agent.listeMessages, function (o) {
              // console.log('o.visiteurID', o.visiteurID)
              return o.visiteurID === data.visiteurID
            })
            if (index !== -1) {
              numMessage++
            }
            // console.log('index', index)
          }
        }
      )
      // console.log('numMessage', numMessage)
      if (numMessage) {
        // console.log('Il existe des messages en attente pour ce visiteur')
        // efface tous cses message en attente
        this.AttenteReponseAgent(data)
      } else {
        // console.log('pas de message en attente')
      }
    },

    // ----------------------------------------------------------------------------
    // Indique si c'est la réponse d'un message en attente
    // ----------------------------------------------------------------------------
    AttenteReponseAgent (data) {
      console.log('AttenteReponseAgent', this.$store.state._StoreWatcheeBox.allDataVisiteurOpened)
      let dataToPost = new window.FormData()
      dataToPost.append('agentId', this.$store.state._StoreWatcheeBox.allDataVisiteurOpened.agentIdSelected)
      dataToPost.append('visiteurId', data.visiteurID)
      dataToPost.append('visiteurEmail', this.$store.state._StoreWatcheeBox.allDataVisiteurOpened.email)
      dataToPost.append('visiteurTel', this.$store.state._StoreWatcheeBox.allDataVisiteurOpened.tel)
      dataToPost.append('visiteurPageFocus', this.$store.state._StoreWatcheeBox.allDataVisiteurOpened.focus)
      dataToPost.append('entName', this.$store.state._User.entName)
      dataToPost.append('message', '')
      dataToPost.append('conseillerName', this.$store.state._User.fname + ' ' + this.$store.state._User.lname)
      // utilise la fiche visiteur pour recuperer le contact
      // afin de lui envoyer par notif la réponse du conseiller
      // console.log('message attente lu : ', dataToPost)
      // mise à jour de la base de donnée
      this.axios
        .post('post/allMessageVisiteurAttenteLu.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          if (response.statusText === 'OK') {
            // si je suis un simple conseiller
            // console.log('modification dans colleagues[]')
            // recherche pour quel agent j'ai répondu
            let idAgentChatOpened = this.$store.state._StoreWatcheeBox.idAgentSelectedListe
            // console.log('idAgentChatOpened', idAgentChatOpened)
            // recupère l'index du message supprimé
            let index = _.findIndex(this.$store.state._User.colleagues, function (o) { return Number.parseInt(o.USR_ID) === Number.parseInt(idAgentChatOpened) })
            console.log('index', index)
            if (index !== -1) {
              // console.log('il y a une liste de message :', idAgentChatOpened)
              if (this.$store.state._User.colleagues[index].listeMessages.length) {
                // clone le tableau avant de travailler dessus
                let messagesList = _.cloneDeep(this.$store.state._User.colleagues[index].listeMessages)
                // console.log('messagesList', messagesList)
                // retire les message corespondant au visiteur qui a eu sa reponse
                let newListe = _.remove(messagesList, function (o) { return o.visiteurID !== data.visiteurID })
                // mise à jour de user.listeMessages
                this.SET_DEL_MESSAGE_ATTENTE({
                  'liste': newListe,
                  'agentId': idAgentChatOpened
                })
              } else {
                // console.log('pas de liste pour :', idAgentChatOpened)
              }
            }
            // ouvre la dialogueBox pour indique la fermeture de la convesation
            // this.dialogCloseChat = true
          }
        })
        .catch()
    },
*/
    // ----------------------------------------------------------------------------
    // ouvre la dialogBox 'fermeChat' sur le btn dans la div de deconnexion .offlineVisiteur
    // quant le visiteur n'est plus la
    // ----------------------------------------------------------------------------
    // fermeChat () {
      // met à jour les switch en regardant les cookies
      // this.settingsFromCookies()
      // ouvre la dialogBox
      // this.dialogCloseChat = true
    // },

    // ----------------------------------------------------------------------------
    // ferme le chat
    // avec option envois formulaire de satisfaction
    // et cloture de chat
    // c'est un message de type 4
    // ----------------------------------------------------------------------------
    fermeChat () {
      // console.log('path : ', this.formulaireSatisfaction)
      // console.log('this.$route.name', this.$route.name)
      // jamais d'envois de formulaire de satisfaction dans la section "attente"
      if (this.$route.name === 'attente' || this.directChat) {
        this.formulaireSatisfaction = false
      }
      this.ACTION_CLOSE_CHAT({
        formulaireSatisfaction: this.formulaireSatisfaction,
        datasVisiteur: this.datasVisiteur,
        clotureChat: this.clotureChat,
        fullPath: this.$route.fullPath,
        namePath: this.$route.name
      })
      // si c'est un chat normale et non un message en attente
      // il faut checker si ce visiteur n'a pas des messages en attente
      // si c'est le cas, il faut les effacer
      // if (this.$route.fullPath !== '/trafic/attente') {
      //   this.checkMessageAttenteVisiteur(this.datasVisiteur)
      // }
      // webhook uniquement si cloture du chat
      // console.log('this.user.webhook', this.user.webhook)
      if (this.user.webhook && this.clotureChat) {
        // si cloture, on envois un webhook
        // mais avant il faut recuperer les infos visiteur de la fiche visiteur
        this.getInfoVisiteur(this.datasVisiteur)
      } else {
        this.fermeDialog()
      }
    },

    // ----------------------------------------------------------------------------
    // affiche les info diu visiteur
    // ----------------------------------------------------------------------------
    getInfoVisiteur (data) {
      let dataToGet = new window.FormData()
      dataToGet.append('session', data.visiteurID)
      dataToGet.append('siteID', data.siteID)
      dataToGet.append('specialtable', this.user.licSpecialtable)
      this.axios.post('get/visitor_info.php', dataToGet, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        // console.log('infoVisiteur', response)
        let _identity = response.data.defaultId
        if (typeof response.data.fname !== 'undefined' && response.data.fname !== '') {
          _identity = response.data.fname
        }
        if (typeof response.data.lname !== 'undefined' && response.data.lname !== '') {
          _identity += ' ' + response.data.lname
        }
        if (_identity === response.data.defaultId) {
          if (typeof response.data.form_fname !== 'undefined' && response.data.form_fname !== '') {
            _identity = response.data.form_fname
          }
          if (typeof response.data.form_lname !== 'undefined' && response.data.form_lname !== '') {
            _identity += ' ' + response.data.form_lname
          }
        }
        data.visiteurName = _identity
        let _email = response.data.email
        if ((!_email || _email === '') && typeof response.data.form_email !== 'undefined' && response.data.form_email !== '') {
          _email = response.data.form_email
        }
        data.email = _email
        let _tel = response.data.tel
        if ((!_tel || _tel === '') && typeof response.data.form_tel !== 'undefined' && response.data.form_tel !== '') {
          _tel = response.data.form_tel
        }
        data.tel = _tel
      })
      .catch((error) => {
        console.log('erreur : ', error)
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$t('error'),
          context: 'error'
        })
      })
      .finally(() => {
        // on peut envois un webhook
        this.webhookClotureChat(data)
      })
    },

    // ----------------------------------------------------------------------------
    // Webhook
    // ----------------------------------------------------------------------------
    webhookClotureChat (data) {
      // console.log('webhookClotureChat data', data)
      // console.log('webhookClotureChat user', this.user)
      // création de l'historique  avec uniquement les messages de la conversation en cours (pas les messages d'une conversation cloturée)
      let newHistoChat = []
      data.histoChat.forEach(message => {
        if (message.chatSession === '0' || (!message.chatSession && !message.dateMessage)) {
          newHistoChat.push(message)
        }
      })
      let lastMessage = newHistoChat.slice(-1)
      // console.log('newHistoChat', newHistoChat.length)
      if (this.user.webhook && newHistoChat.length) {
        // console.log('lastMessage', lastMessage)
        // console.log('newHistoChat.length', newHistoChat.length())
        // encodage en base64 du lopgin et mot de passe
        const token = Buffer.from(this.user.webhook.login + ':' + this.user.webhook.password, 'utf8').toString('base64')
        // console.log('token', token)
        let dataToPost = {
          'type': 'closureChat',
          'data': {
            'start': Number(newHistoChat[0].timestamp), // heure du premier message
            'end': Number(lastMessage[0].timestamp), // heure du dernier message
            'visteurId': data.visiteurID,
            'visteurName': data.visiteurName,
            'visteurEmail': data.email,
            'visteurPhone': data.tel,
            'agent': this.fullName,
            'chat': newHistoChat
          }
        }
        this.axios.post(this.user.webhook.url,
          dataToPost, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Basic ${token}`
            }
            // headers: {'Content-Type': 'multipart/form-data'},
            // onDownloadProgress: (progressEvent) => {
            //   // console.log('onprogress', progressEvent)
            //   this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100))
            // }
          }
        ).then(response => {
          console.log('webhook response', response)
        })
        .catch(error => {
          // this.loadingUpload = false
          console.log('erreur : ', error)
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('error'), context: 'error' })
        })
        .finally(() => {
          // on peut fermer la dialogbox
          this.fermeDialog()
        })
      }
    },

    settingsFromCookies () {
      this.formulaireSatisfaction = this.$cookie.get('wz-satisfaction-survey') === 'true' || false
      this.clotureChat = this.$cookie.get('wz-closing-chat') === 'true' || false
    }
  },

  watch: {
    // ----------------------------------------------------------------------------
    // garde des infos sur le visiteur même si il est deconnecté
    // ----------------------------------------------------------------------------
    datasVisiteur: function (val, oldval) {
      if (!val) {
        this.dataWatchVisteur = oldval
      } else {
        this.dataWatchVisteur = val
      }
    },

    dialogCloseChat: function (val, oldval) {
      if (this.$route.fullPath === '/trafic/attente' || this.directChat) {
        if (val) {
          this.startTimer()
        }
      }
    },

    formulaireSatisfaction (v) {
      this.$cookie.set('wz-satisfaction-survey', v, { expires: '1Y' })
    },

    clotureChat (v) {
      this.$cookie.set('wz-closing-chat', v, { expires: '1Y' })
    },
    timeLeft (newValue) {
      if (newValue === 0) {
        this.onTimesUp()
      }
    }

  },

  mounted () {
    // au chargement on recupere le 'datavisiteur'
    // car le 'dataWatchVisiteur' est vide, pas encore passé dans le watch
    this.dataWatchVisteur = this.datasVisiteur
    if (this.dataWatchVisteur.network === 'facebook') {
      this.visitorLeft = 'no'
    }

    if (this.$store.state._User.entKey === '9c44184c124fda32ac19523ff93d2488') {
      this.checkForMotif = true
    }

    this.settingsFromCookies()
    this.id_conversation = 'conversation_' + this.datasVisiteur.visiteurID
  },

  beforeDestroy () {
  },

  computed: {
    ...mapState('_StoreWatcheeBox', [
      'listeAllVisiteurs',
      'sessionsPrivees'
    ]),
    ...mapState('_User', ['entLevel']),
    ...mapGetters('_User', ['user', 'fullName']),
    ...mapGetters('_StoreWatcheeBox', ['WATCHEEBOX_STATE']),

    hasMotif () {
      // let thisVisit = _.find(this.$store.state._StoreWatcheeBox.listeAllVisiteurs, {
      //   visiteurID: this.dataWatchVisteur.visiteurID
      // })
      // return thisVisit ? thisVisit.motif : false
      return true
    },
    // bloque l'envois du formulaire de satisfaction si pas la bonne licence
    checkSatisfaction () {
      let inactif = false
      if (this.entLevel === '10' || this.entLevel === '1') {
        inactif = true
      }
      return inactif
    },
    // masque l'envoie du formulaire chez Kaufman KetB
    checkKetB () {
      if (this.$store.state._User.ketb === 1) {
        return false // pour le v-show
      } else {
        return true
      }
    },

    // timer
    timeLeft () {
      return this.timeLimit - this.timePassed
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheebox/WzDialogCloseChat.vue